import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
// import { isPc } from './utils/index'
// import CommenHeader from './components/header'
// import CommenFooter from './components/footer'
import Home from './pages/home'
import NotFound from './pages/404'
// 移动端组件
// import MobileHome from './pages/mobile/home'
// import MobileHeader from './pages/mobile/components/header'
// import MobileFooter from './pages/mobile/components/footer'
import './App.css'

function App() {
  return (
    <BrowserRouter>
      {/* 头部 */}
      {/* {isPc() ? <CommenHeader /> : <MobileHeader />} */}
      {/* 内容 */}
      <Routes>
        {/* 首页 */}
        <Route path="/" element={<Home />} />
        {/* 404页面 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      {/* 脚部 */}
      {/* {isPc() ? <CommenFooter /> : <MobileFooter />} */}
      {/* 悬浮窗 */}
      {/* {isPc() ? <NavList /> : <MobileNavList />} */}
    </BrowserRouter>
  )
}

export default App
